import React from "react";
import { NextPage } from "next";
import { dehydrate, QueryClient } from "react-query";
import Market from "../../modules/Marketplace/Market/Market";
import { getPrefetchQueryWrapper } from "../../helpers/nextHelper";
import { QueryKeys } from "../../common/queryKeys";
import { getMarketFilterValues } from "../../helpers/marketHelper";
import {
  fetchMarketFilters,
  fetchMarketPage,
} from "../../queries/market.query";

const AssetsPage: NextPage = () => <Market />;

AssetsPage.getInitialProps = getPrefetchQueryWrapper(async (ctx) => {
  const filters = getMarketFilterValues(ctx.query);
  const queryClient = new QueryClient();

  await Promise.all([
    queryClient.prefetchQuery(QueryKeys.marketFilters, fetchMarketFilters),
    queryClient.prefetchInfiniteQuery([QueryKeys.marketData, filters], () =>
      fetchMarketPage(0, filters)
    ),
  ]);

  return {
    dehydratedState: dehydrate(queryClient),
  };
});

export default AssetsPage;
